import { useState } from 'react';
import moment from 'moment';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';

export const useOfferCommon = ({ saleStatus, getAmount, getDate }) => {
  const [currentSortAmount, setCurrentSortAmount] = useState('default');
  const [currentSortCreatedAt, setCurrentSortCreatedAt] = useState('default');
  const [currentSortedColumn, setCurrentSortedColumn] = useState('amount');

  const sortTypes = {
    amount: {
      down: {
        icon: faSortDown,
        fn: (a, b) => getAmount(a) - getAmount(b),
      },
      up: {
        icon: faSortUp,
        fn: (a, b) => getAmount(b) - getAmount(a),
      },
      default: {
        icon: faSort,
        fn: (a) => a,
      },
    },
    lastOfferCreatedAt: {
      down: {
        icon: faSortDown,
        fn: (a, b) => moment(getDate(a)) - moment(getDate(b)),
      },
      up: {
        icon: faSortUp,
        fn: (a, b) => moment(getDate(b)) - moment(getDate(a)),
      },
      default: {
        icon: faSort,
        fn: (a) => a,
      },
    },
  };

  const onSortChange = (sortColumnParam) => {
    let nextSort;
    if (sortColumnParam === 'amount') {
      if (currentSortAmount === 'down') nextSort = 'up';
      else if (currentSortAmount === 'up') nextSort = 'default';
      else if (currentSortAmount === 'default') nextSort = 'down';
      setCurrentSortAmount(nextSort);
      setCurrentSortCreatedAt('default');
    } else if (sortColumnParam === 'lastOfferCreatedAt') {
      if (currentSortCreatedAt === 'down') nextSort = 'up';
      else if (currentSortCreatedAt === 'up') nextSort = 'default';
      else if (currentSortCreatedAt === 'default') nextSort = 'down';
      setCurrentSortCreatedAt(nextSort);
      setCurrentSortAmount('default');
    }
    setCurrentSortedColumn(sortColumnParam);
  };

  const sortTarget = currentSortedColumn === 'amount' ? currentSortAmount : currentSortCreatedAt;
  const sortFunction = sortTypes[currentSortedColumn][sortTarget].fn;

  const isFinished = [
    'CLOSED',
    'FINISHED',
    'ARCHIVED',
    'winner_to_designate',
    'winnerToDesignate',
    'closed_order_confirmed',
    'stockClosedOrderConfirmed',
    'closed_no_purchase',
    'stockClosedNoPurchase',
  ].includes(saleStatus);

  return {
    sortTypes,
    onSortChange,
    sortTarget,
    currentSortedColumn,
    currentSortAmount,
    currentSortCreatedAt,
    sortFunction,
    isFinished,
  };
};
